import React, { } from 'react';
import { RouteProps } from "react-router";
import { HashRouter, Switch, Route } from 'react-router-dom';
import { constantConfig } from 'web-common';

// page
import { Container } from '../page/common/Container';

import Forbidden from "../page/common/Forbidden";
import NotFound from "../page/common/NotFound";

import Home from "../page/Home/Index";
import Product from "../page/Product/Index";
import Service from "../page/Service/Index";
import AboutUs from "../page/AboutUs/Index";
import { AboutUsPublicize } from '../page/AboutUs/indexPublicizeJzfz';
import ContactUs from '../page/ContactUs/ContactUs';
import { NoticeInfo } from '../page/ContactUs/NoticeInfo';
import { NoticeList } from '../page/ContactUs/NoticeList';
import News from '../page/News/Index';
import { Periodical } from '../page/Read/Periodical';
import { Aesthetice } from '../page/Read/Aesthetice';
import { Search } from '../page/Search/Search';
import Integrity from '../page/Integrity/index';


const { WEBSITE_PATHS } = constantConfig;


// 外层路由
export const routes = [
	{
		path: '/',
		component: Container,
		routes: [
			// 首页
			{ path: WEBSITE_PATHS.home, component: Home, exact: true, title: '首页' },
			// 关于我们
			{ path: WEBSITE_PATHS.aboutUs, component: AboutUs, exact: true, title: '关于' },
			// 关于我们-jzfz宣传页
			{ path: WEBSITE_PATHS.aboutUsPublicize, component: AboutUsPublicize, exact: true, title: '关于' },
			// 作品
			{ path: WEBSITE_PATHS.product, component: Product, exact: true, title: '作品' },
			// 服务
			{ path: WEBSITE_PATHS.service, component: Service, exact: true, title: '服务' },
			// 新闻动态
			{ path: WEBSITE_PATHS.news, component: News, exact: true, title: '动态' },
			// 阅读
			{ path: WEBSITE_PATHS.read, component: Periodical, exact: true, title: '阅读' },
			// 基准之道
			{ path: WEBSITE_PATHS.periodical, component: Periodical, exact: true, title: '基准之道' },
			// 视觉美学
			{ path: WEBSITE_PATHS.aesthetice, component: Aesthetice, exact: true, title: '视觉美学' },
			// 联系我们首页
			{ path: WEBSITE_PATHS.contactUs, component: ContactUs, exact: true, title: '联系' },
			// 联系我们 - 通知公告列表
			{ path: WEBSITE_PATHS.noticeList, component: NoticeList, exact: true, title: '联系我们-通知公告列表' },
			// 联系我们 - 单个公告
			{ path: WEBSITE_PATHS.noticeInfo, component: NoticeInfo, exact: true, title: '联系我们-单个公告详情' },
			// 搜索结果
			{ path: WEBSITE_PATHS.search, component: Search, exact: true, title: '搜索结果' },
			// 贪腐解聘查询
			{ path: WEBSITE_PATHS.integrityInquiry, component: Integrity, exact: true, title: '贪腐解聘查询' },
		]
	},

	{ path: "/403", component: Forbidden },

	{ path: "/404", component: NotFound },

	{ path: "*", component: NotFound },
];


/**
 * 根路由
 * @returns {*}
 * @constructor
 */
export const IndexRouter = () => (
	<HashRouter>
		<Switch>
			{
				routes.map((route: any, index: number) => {
					if (route.routes) {
						return <route.component key={index} {...route} />;
					}
					return <Route key={index} {...route} />;
				})
			}
		</Switch>
	</HashRouter>
);
